import { KEYCLOAK_PATH } from './utils/config';
import Keycloak from '@icarros/keycloak-js';

const keycloak = new Keycloak(KEYCLOAK_PATH);

export default keycloak;
